module.exports = __webpack_public_path__ + "static/Akebia_MOD_Animation_04_Current_Therapeutic_Landscape_due_to_CKD-506534cf1c844b41d2237958bd8a8269.mp4";